import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedPrimeNgModule } from './shared-primeng.module';
import { SharedMaterialModule } from './shared-material.module';
import { BaseDashboardComponent } from '../components/base-dashboard/base-dashboard.component';

@NgModule({
  declarations: [
    BaseDashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPrimeNgModule,
    SharedMaterialModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPrimeNgModule,
    SharedMaterialModule,
    BaseDashboardComponent
  ]
})
export class SharedModule { }